// import $ from 'jquery';
import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/products/views/Filter.html';


class View extends TemplateView {

	get template() {
		return Template;
	}

	get data() {
		return {
			subcategories: this.options.subcategories
		};
	}

}

export default View;
